import Item from "./Item";
import Supplier from "./Supplier";

export default class SupplierItem {
  constructor(
    public id: number,
    public supplier: Supplier,
    public item: Item,
    public code: string,
    public orderUnitCode: string,
    public factor: number,
    public baseUnitCode: string,
    public name: string | undefined,
    public description: string | undefined,
    public proposedOrderQuantity: number | undefined,
  ) {}
}
